import { render, staticRenderFns } from "./FolioForm.vue?vue&type=template&id=5020b0b8"
import script from "./FolioForm.vue?vue&type=script&lang=js"
export * from "./FolioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports